import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';

import BaseAddressPicker from './address-picker/';
import BaseSelect from './Select';
import BaseTextInput from './input';

import debounce from 'debounce';

import trackTextField from '../actions/track-text-field';

export default function wrapInput(InputType) {
  const StyledInputType = styled(InputType)`
    background-color: ${props => props.theme.lightestGray};
    border: 1px solid ${props => props.theme.border};
    border-radius: 3px;
    font-family: ${props => props.theme.baseFontFamily};
    font-size: 1em !important;
    margin-bottom: 0.5em;
    color: ${props => props.theme.text};
    font-weight: 300;

    &::placeholder {
      color: ${props => props.theme.placeholder};
    }
    ${down('sm')} {
      font-size: 70%;
    }
  `;

  return connect(undefined, { trackTextField })(
    class TrackingTextInput extends Component {
      constructor(props) {
        super(props);
        this.trackInput = debounce(this.props.trackTextField, 500);
      }

      static defaultProps = {
        trackValue: true,
        onChange: () => {},
        onKeyPress: () => {},
      };

      static propTypes = {
        name: PropTypes.string.isRequired,
        trackValue: PropTypes.bool,
        onChange: PropTypes.func,
        onKeyPress: PropTypes.func,
        step: PropTypes.string.isRequired,
      };

      render() {
        const {
          className,
          onChange,
          trackValue,
          name,
          step,
          trackTextField, // eslint-disable-line
          ...otherProps
        } = this.props;

        return (
          <StyledInputType
            className={className}
            data-cy={'input-value'}
            name={name}
            onChange={(value, label) => {
              this.trackInput({
                name,
                step,
                value: trackValue ? value : '(filtered)',
              });
              onChange(value, label);
            }}
            {...otherProps}
          />
        );
      }
    }
  );
}

export const Select = wrapInput(BaseSelect);
export const TextInput = wrapInput(BaseTextInput);
export const PlainTextArea = wrapInput(props => {
  return (
    <StyledTextArea {...props} onChange={e => props.onChange(e.target.value)} />
  );
});
export const AddressPicker = wrapInput(BaseAddressPicker);

const StyledTextArea = styled.textarea``;
